import { Meter } from "@base-ui/react/meter";
import { useTransferStore } from "../store/transferStore";

/**
 * Visualizes how many of the source clips' animated bones exist in the target
 * skeleton, using Base UI's accessible Meter primitive.
 */
export function BoneMeter() {
  const match = useTransferStore((s) => s.match);
  if (!match || match.total === 0) return null;

  const tone = match.hit === match.total ? "ok" : match.hit === 0 ? "err" : "warn";

  return (
    <Meter.Root
      className="meter"
      value={match.hit}
      max={match.total}
      getAriaValueText={(_, value) => `${value} of ${match.total} bones matched`}
    >
      <div className="meter-head">
        <Meter.Label className="meter-label">Bone match</Meter.Label>
        <Meter.Value className="meter-value">
          {() => `${match.hit}/${match.total}`}
        </Meter.Value>
      </div>
      <Meter.Track className="meter-track">
        <Meter.Indicator className={`meter-indicator ${tone}`} />
      </Meter.Track>
    </Meter.Root>
  );
}
